import { render, staticRenderFns } from "./MyTcTickets.vue?vue&type=template&id=ffc4d6f0&scoped=true&"
import script from "./MyTcTickets.vue?vue&type=script&lang=js&"
export * from "./MyTcTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc4d6f0",
  null
  
)

export default component.exports